import { VSElementModel, VSImageShapeOrTextElementModel } from 'js/types';

const isVSElementsOnly = (element: VSElementModel): element is VSImageShapeOrTextElementModel => {
  return element.type !== 'Camera';
};

export const noCameras = (elements: Array<VSElementModel>): Array<VSImageShapeOrTextElementModel> => {
  return elements.filter(isVSElementsOnly);
};
